import { SmsMessageDetails } from "../../../dispatch/src/SmsMessageDetails";
import { SmsFieldsContainer } from "../SmsFieldsContainer";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSendSmsMessageSlideout extends Layout {
    horizontalspacer3: HorizontalSpacer;
    labelAddToMessage: Label;
    labelLink: Label;
    labelMessageId: Label;
    labelMessageText: Label;
    labelReferenceNumbers: Label;
    labelRequestLocation: Label;
    layoutSmsFieldsContainer: SmsFieldsContainer;
    layoutSmsFieldsContainerTextLocate: SmsFieldsContainer;
    layoutSmsMessageDetail: SmsMessageDetails;
    panelCharactersUsed: Panel;
    panelMessageText: Panel;
    panelMessageTextContainer: Panel;
    panelSmsTextContainer: Panel;
    panelTemplates: Panel;
    smsMessageText: Textbox;
    sourceCarrierDriverContacts: DataSource;
    sourceCarrierDriverMessage: DataSource;
    sourceMovement: DataSource;
    switchCellPhone: Switch;
    switchComments: Switch;
    switchContactInfo: Switch;
    switchDirections: Switch;
    switchDirectionsDisclaimer: Switch;
    switchDistBetweenStops: Switch;
    switchDoNotCall: Switch;
    switchEmailAddr: Switch;
    switchOfficePhone: Switch;
    switchReferenceNumbers: Switch;
    switchSchedArrivalTimes: Switch;
    switchStopName: Switch;
    tabSendSmsMessage: Tab;
    tabTextLocate: Tab;
    tabset1: Tabset;
    textboxCharacters: Textbox;
    textboxCharactersRemaining: Textbox;
    textboxNumofTextMessages: Textbox;
}
